import { TruckerConfirmItem } from "./TruckerConfirmItem";

export class TruckerConfirmResults {
	emailSendComplete: boolean = false;
	emailSuccess: boolean = false;
	emailResult: string = '';
	rogerSendComplete: boolean = false;
	rogerSuccess: boolean = false;
	rogerResult: string = '';
	compuweighSendComplete: boolean = false;
	compuweighSuccess: boolean = false;
	compuweighResult: string = '';
	scheduleIds: number[] = [];
	textResult: boolean = false;
	confirmItems: TruckerConfirmItem[] = [];
}